import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import OnboardingWizardContentWrapper from '../OnboardingWizardWrappers/OnboardingWizardContentWrapper/OnboardingWizardContentWrapper';
import DiscussionTopicsEmptyState from '../DiscussionTopics/DiscussionTopicsListPreview/DiscussionTopicsEmptyState/DiscussionTopicsEmptyState';
import WorkspacesPreview from '../WorkspacesPreview/WorkspacesPreview';
import { WorkspacesType } from '../../types';
import FormFields from './FormFields/FormFields';
import { generateEmptyWorkspace } from './utils';

import './Workspaces.scss';

type Props = {
  workspaces: WorkspacesType;
  advanceOnboardingState: Function;
  numDirectReports: number;
};

function Workspaces({
  workspaces: initWorkspaces,
  advanceOnboardingState,
  numDirectReports: initNumDirectReports,
}: Props) {
  const noMeetingsFoundAfterConnectCalendar = useSelector(
    state =>
      state.onboardingState?.flowType === 'calendar_integration' &&
      state.onboardingState?.recurringMeetings.length === 0 &&
      state.onboardingState?.userCreatedInMiddle
  );
  const handleSubmit = useCallback(
    ({ workspaces, numDirectReports }) => {
      return advanceOnboardingState({
        workspaces: workspaces.filter(({ uuid, fullName }) => uuid && fullName),
        num_direct_reports: numDirectReports,
      });
    },
    [advanceOnboardingState]
  );

  const formValidate = useCallback(values => {
    if (values.workspaces && values.workspaces.some(item => item.fullName)) return {};
    return { error: 'Required field' };
  }, []);

  const errorsDisableSubmit = useCallback(errors => {
    if (errors.workspaces) {
      if (errors.workspaces.some(workspace => workspace && Object.keys(workspace).some(k => k !== 'email'))) {
        return true;
      }
    }
    if (Object.keys(errors).some(e => e !== 'workspaces')) return true;
    return false;
  }, []);

  return (
    <OnboardingWizardContentWrapper
      initialValues={{
        workspaces: initWorkspaces.length ? initWorkspaces : [generateEmptyWorkspace()],
        numDirectReports: initNumDirectReports,
      }}
      onNextStep={handleSubmit}
      previewSectionContent={<WorkspacesPreview workspaceContent={<DiscussionTopicsEmptyState />} />}
      formValidate={formValidate}
      errorsDisableSubmit={errorsDisableSubmit}
    >
      <div className="d-flex flex-column onboarding-workspaces">
        <h4 className="padding-right-50">
          {noMeetingsFoundAfterConnectCalendar
            ? 'We couldn’t find any 1:1 meetings in your calendar. Let’s manually create some workspaces instead.'
            : 'Nice work! Now, let’s create workspaces for all of your 1:1’s.'}
        </h4>
        <FormFields />
      </div>
    </OnboardingWizardContentWrapper>
  );
}

export default Workspaces;
